export default {
  workingTime: {
    workingTime: "เวลาการทำงาน",
    dateTime: "วันที่/เวลา",
    clockInTime: "เวลาเข้างาน",
    clockOutTime: "เวลาออกงาน",
    clockInType: "ประเภทเข้างาน",
    clockOutType: "ประเภทออกงาน",
    all: "ทั้งหมด",
    auto: "อัตโนมัติ",
    AUTO: "อัตโนมัติ",
    manual: "ด้วยตัวเอง",
    MANUAL: "ด้วยตัวเอง",
    forceClockOut: "บังคับออกงาน",
    FORCE_CLOCK_OUT: "บังคับออกงาน",
    filter: "ตัวกรอง",
    resetFilter: "รีเซ็ตตัวกรอง",
    noData: "ไม่มีข้อมูล",
    driver: "คนขับ",
    recordNo: "ลำดับ",
    workingHour: "เวลาทำงาน",
    clockInLocation: "สถานที่เข้างาน",
    clockInLatLng: "พิกัดที่เข้างาน",
    clockOutLocation: "สถานที่ออกงาน",
    clockOutLatLng: "พิกัดที่ออกงาน",
    search: "ค้นหา...",
    driverName: "ชื่อคนขับรถ",
    driverId: "รหัสคนขับรถ",
    hrs: "ชม.",
    mins: "นาที",
    null: "",
  },
};



// WEBPACK FOOTER //
// ./src/lang/th/pages/workingTime/workingTime.js